import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function OdemeFormu() {
  const { siparisNo } = useParams();
  const [siparis, setSiparis] = useState(null);
  const [kalemler, setKalemler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bulunamadi, setBulunamadi] = useState(false);
  const [tamamlandi, setTamamlandi] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');

  const [form, setForm] = useState({ ad_soyad: '', telefon: '', adres: '' });

  useEffect(() => { fetchSiparis(); }, [siparisNo]);

  async function fetchSiparis() {
    const { data: s, error } = await supabase
      .from('siparisler')
      .select('*, musteriler(*), firmalar(ad)')
      .eq('siparis_no', siparisNo)
      .single();

    if (error || !s) { setBulunamadi(true); setLoading(false); return; }

    if (s.odeme_durumu === 'odendi') { setTamamlandi(true); setSiparis(s); setLoading(false); return; }

    const { data: k } = await supabase.from('siparis_kalemleri').select('*, urunler(ad)').eq('siparis_id', s.id);

    setSiparis(s);
    setKalemler(k || []);
    if (s.musteriler?.ad) setForm(f => ({ ...f, ad_soyad: s.musteriler.ad }));
    if (s.musteriler?.telefon) setForm(f => ({ ...f, telefon: s.musteriler.telefon }));
    if (s.adres) setForm(f => ({ ...f, adres: s.adres }));
    setLoading(false);
  }

  async function handleGonder() {
    if (!form.ad_soyad.trim()) { setHata('Ad Soyad gerekli'); return; }
    setHata('');
    setYukleniyor(true);
    try {
      // Müşteri bilgilerini güncelle
      if (siparis.musteri_id) {
        await supabase.from('musteriler').update({
          ad: form.ad_soyad,
          telefon: form.telefon,
        }).eq('id', siparis.musteri_id);
      }
      // Sipariş güncelle — ödeme bekleniyor olarak işaretle
      await supabase.from('siparisler').update({
        adres: form.adres,
        not_: (siparis.not_ ? siparis.not_ + ' | ' : '') + `Müşteri bilgileri iletildi. Dekont bekleniyor.`,
      }).eq('id', siparis.id);

      setTamamlandi(true);
    } catch (err) {
      setHata('Bir hata oluştu: ' + err.message);
    }
    setYukleniyor(false);
  }

  if (loading) return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', padding: 40, color: '#888' }}>Yükleniyor...</div>
      </div>
    </div>
  );

  if (bulunamadi) return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
          <h2 style={{ color: '#fff', marginBottom: 8 }}>Sipariş Bulunamadı</h2>
          <p style={{ color: '#888' }}>Bu ödeme linki geçersiz veya süresi dolmuş olabilir.</p>
        </div>
      </div>
    </div>
  );

  if (tamamlandi) return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
          <h2 style={{ color: '#4ade80', marginBottom: 8, fontSize: 24 }}>Bilgileriniz Alındı!</h2>
          <p style={{ color: '#aaa', marginBottom: 16 }}>
            Sipariş No: <strong style={{ color: '#fff' }}>#{siparisNo}</strong>
          </p>
          <div style={{ background: '#1a1d27', borderRadius: 10, padding: 16, textAlign: 'left', marginBottom: 16 }}>
            <p style={{ color: '#aaa', fontSize: 13, marginBottom: 8 }}>Ödeme talimatı:</p>
            <p style={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>
              {siparis?.odeme_turu === 'banka' ? '🏦 Banka Havalesi' : siparis?.odeme_turu === 'kredi_karti' ? '💳 Kredi Kartı' : '💵 Elden/Nakit'}
            </p>
            <p style={{ color: '#E07B00', fontSize: 20, fontWeight: 800, marginTop: 8 }}>
              {(siparis?.toplam_tutar || 0).toLocaleString('tr-TR')} ₺
            </p>
          </div>
          <p style={{ color: '#888', fontSize: 13 }}>
            Ödemenizi yaptıktan sonra dekontunuzu WhatsApp üzerinden temsilcinize gönderin.
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={sayfaStyle}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#E07B00', letterSpacing: -1 }}>
          {siparis.firmalar?.ad || 'Ödeme'}
        </div>
        <div style={{ color: '#888', fontSize: 14, marginTop: 4 }}>Sipariş Bilgi Formu</div>
      </div>

      <div style={kartStyle}>
        {/* SİPARİŞ ÖZETİ */}
        <div style={{ marginBottom: 24, padding: 16, background: '#1a1d27', borderRadius: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ color: '#888', fontSize: 13 }}>Sipariş No</span>
            <span style={{ color: '#fff', fontWeight: 700, fontFamily: 'monospace' }}>#{siparisNo}</span>
          </div>
          {kalemler.length > 0 && (
            <div style={{ borderTop: '1px solid #2a2d3a', paddingTop: 10, marginTop: 8 }}>
              {kalemler.map(k => (
                <div key={k.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                  <span style={{ color: '#bbb' }}>{k.urunler?.ad} <span style={{ color: '#666' }}>×{k.miktar}</span></span>
                  <span style={{ color: '#fff' }}>{(k.toplam || 0).toLocaleString('tr-TR')} ₺</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #2a2d3a', paddingTop: 10, marginTop: 8 }}>
            <span style={{ color: '#888', fontSize: 14 }}>Ödenecek Tutar</span>
            <span style={{ color: '#E07B00', fontWeight: 800, fontSize: 20 }}>
              {(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺
            </span>
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
            Ödeme Türü: {siparis.odeme_turu === 'banka' ? 'Banka Havalesi' : siparis.odeme_turu === 'kredi_karti' ? 'Kredi Kartı' : 'Elden/Nakit'}
          </div>
        </div>

        <h3 style={{ color: '#fff', fontSize: 15, fontWeight: 700, marginBottom: 16 }}>Bilgilerinizi Onaylayın</h3>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Ad Soyad *</label>
          <input style={inputStyle} value={form.ad_soyad}
            onChange={e => setForm(f => ({ ...f, ad_soyad: e.target.value }))}
            placeholder="Adınız ve Soyadınız" />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Telefon</label>
          <input style={inputStyle} value={form.telefon}
            onChange={e => setForm(f => ({ ...f, telefon: e.target.value }))}
            placeholder="05XX XXX XX XX" type="tel" />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={labelStyle}>Teslimat Adresi</label>
          <textarea style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }}
            value={form.adres}
            onChange={e => setForm(f => ({ ...f, adres: e.target.value }))}
            placeholder="Adresinizi yazınız..." />
        </div>

        <div style={{ background: 'rgba(224,123,0,0.1)', border: '1px solid rgba(224,123,0,0.3)', borderRadius: 10, padding: 14, marginBottom: 20 }}>
          <p style={{ color: '#E07B00', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>📌 Ödeme Talimatı</p>
          <p style={{ color: '#aaa', fontSize: 13 }}>
            Formu gönderdikten sonra ödemenizi yapın ve dekontunuzu WhatsApp üzerinden temsilcinize iletin.
          </p>
        </div>

        {hata && (
          <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: 13, marginBottom: 16 }}>
            ⚠️ {hata}
          </div>
        )}

        <button
          style={{ width: '100%', padding: '14px', borderRadius: 10, border: 'none', background: yukleniyor ? '#555' : '#E07B00', color: '#fff', fontWeight: 700, fontSize: 16, cursor: yukleniyor ? 'not-allowed' : 'pointer' }}
          onClick={handleGonder}
          disabled={yukleniyor}>
          {yukleniyor ? '⏳ Gönderiliyor...' : '✓ Bilgileri Onayla'}
        </button>

        <p style={{ textAlign: 'center', color: '#555', fontSize: 11, marginTop: 16 }}>
          🔒 Bilgileriniz güvende.
        </p>
      </div>
    </div>
  );
}

const sayfaStyle = { minHeight: '100vh', background: '#0f1117', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: '32px 16px 60px' };
const kartStyle = { width: '100%', maxWidth: 480, background: '#161921', borderRadius: 16, padding: 24, border: '1px solid #2a2d3a' };
const labelStyle = { display: 'block', color: '#aaa', fontSize: 12, marginBottom: 6, fontWeight: 600 };
const inputStyle = { width: '100%', background: '#1a1d27', border: '1px solid #2a2d3a', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' };
